export const FRISTEN_ACTIVITY = "FRISTEN_ACTIVITY";

export const SortingPaths = {
	Erfuellt: "/root/Erfuellt",
	ProcessId: "/root/ProcessId",
	Fristbeginn: "/root/Fristbeginn",
	Fristende: "/root/Fristende",
	WVLErledigt: "/root/IntegrierteWiedervorlage/Wiedervorlage/Erledigt",
	WVLFaelligkeitsdatum: "/root/IntegrierteWiedervorlage/Wiedervorlage/Faelligkeitsdatum"
};
